import { render, staticRenderFns } from "./WorkflowInactivityDaysLimitModal.vue?vue&type=template&id=69f0d268&scoped=true"
import script from "./WorkflowInactivityDaysLimitModal.vue?vue&type=script&lang=js"
export * from "./WorkflowInactivityDaysLimitModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowInactivityDaysLimitModal.vue?vue&type=style&index=0&id=69f0d268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f0d268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
